// ============================================================
// OCCURRENCE SERVICE
// ============================================================
//
// Database access for recurring-task Occurrences.
//
// The recurrence engine decides WHAT an occurrence is.
// This service decides HOW an occurrence is stored/retrieved.
//
// ============================================================

import { supabase } from '../../../supabaseClient'


// ============================================================
// SAVE OCCURRENCE
// ============================================================

export async function saveOccurrence(occurrence) {

  const template =
    occurrence?.template

  if (!template?.id) {
    console.error(
      'Cannot save occurrence: missing recurring template'
    )

    return null
  }

  const payload = {

    recurring_task_id:
      template.id,

    user_id:
      template.user_id || null,

    occurrence_date:
      occurrence.operationalDate || null,

    due_date:
      occurrence.dueDate || null,

    expected:
      occurrence.expected ?? true,

    decision_code:
      occurrence.code || null,

    decision_reason:
      occurrence.reason || null,

    task_id:
      occurrence.taskId || null,

    generated_at:
      occurrence.taskCreated
        ? new Date().toISOString()
        : null,

    skipped_at:
      occurrence.skipped
        ? new Date().toISOString()
        : null,

    missed_at:
      occurrence.missed
        ? new Date().toISOString()
        : null

  }

  const { data, error } =
    await supabase
      .from('occurrences')
      .upsert(
        payload,
        {
          onConflict:
            'recurring_task_id,occurrence_date'
        }
      )
      .select()
      .single()

  if (error) {

    console.error(
      'Occurrence Save Error:',
      error
    )

    return null
  }

  return data
}


// ============================================================
// FIND OCCURRENCE
// ============================================================

export async function findOccurrence({
  recurringTaskId,
  occurrenceDate
}) {

  if (
    !recurringTaskId ||
    !occurrenceDate
  ) {
    return null
  }

  const { data, error } =
    await supabase
      .from('occurrences')
      .select('*')
      .eq(
        'recurring_task_id',
        recurringTaskId
      )
      .eq(
        'occurrence_date',
        occurrenceDate
      )
      .maybeSingle()

  if (error) {

    console.error(
      'Occurrence Lookup Error:',
      error
    )

    return null
  }

  return data
}


// ============================================================
// GET OCCURRENCES FOR TEMPLATE
// ============================================================

export async function getOccurrencesForTemplate(
  recurringTaskId
) {

  if (!recurringTaskId) {
    return []
  }

  const { data, error } =
    await supabase
      .from('occurrences')
      .select('*')
      .eq(
        'recurring_task_id',
        recurringTaskId
      )
      .order(
        'occurrence_date',
        {
          ascending: false
        }
      )

  if (error) {

    console.error(
      'Occurrence Fetch Error:',
      error
    )

    return []
  }

  return data || []
}